<template>
	<!-- 往期限免 -->
	<div class="wqxmBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- $router.back(-1) -->
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile" v-model="title">{{title}}</p>
					<div class="rightSelect" @click="showSelectBox" v-if="index == 0">
						<p v-if="selectValue == null && selectDate == null">榜单期数</p>
						<p v-if="selectValue != null && selectDate != null">第{{selectValue}}期&nbsp;&nbsp;{{selectDate}}</p>
						<img src="../../assets/img/selectArr.png" alt="">
					</div>
					<ul class="selectItem" v-show="showSelect && index == 0">
						<li v-for="(selectItem,index) in showSelectLists" :key="index" @click="selectItemFn(selectItem,index)" :class="selectIndex == index ? 'active_color' : '' ">
							<span v-if='selectItem.date == null && selectItem.time == null'>榜单期数</span>
							<span v-else>第{{selectItem.date}}期&nbsp;&nbsp;&nbsp;{{selectItem.time}}</span>
						</li>
					</ul>
				</div>
			</div>
		</van-sticky>
		<!-- 列表数据 -->
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取" v-if="sc_isLoading == true">
			<div v-if="fmOrListFn">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多啦" offset="10" :immediate-check="false" @load="onLoad">
					<div class="blockBox" v-if="index == 15">
						<div class="blockLeft" v-for="(item,index) in fileList" :key="index" v-if="item.books_id != null || item.book_id != null">
							<div class="book_Img">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>

							<div class="blockBookInfo">
								<div class="bookName">
									<span class="bookTxtBox" v-if="item.book_name">
										<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
										<!-- <span :style="{width:(item.book_name.length * 1 ) + 'em' }" v-for="(item,idx) in item.book_name">{{item.book_name}}</span> -->
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.books_name"></van-notice-bar>
										<!-- <span :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</span> -->
									</span>
								</div>
								<div class="auther"><span></span>
									<p><span>万字</span></p>
								</div>
								<p class="introduction">{{item.introduce}}</p>
							</div>
						</div>
						<div class="nulldata" v-if="bookInfoList.length == 0">
							<img src="../../assets/img/data_null.png" alt="">
						</div>
						<!-- <div class="onFooter" v-show="onFooter==1">到底啦</div> -->
					</div>
					<div class="blockBox" v-else>
						<div class="blockLeft" v-for="(item,index) in bookInfoList"  v-if="wj_show == false && item.books_id != null || item.book_id != null">
							<div class="book_Img" @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? true : false">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>

							<div class="book_Img" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? false : true">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>

							<div class="blockBookInfo" @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? true : false">
								<div class="bookName">
									<span class="bookTxtBox" v-if="item.book_name">
										<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
										<!-- <span :style="{width:(item.book_name.length * 1 ) + 'em' }">{{item.book_name}}</span> -->
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.books_name"></van-notice-bar>
										<!-- <span :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</span> -->
									</span>
								</div>
								<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
								</div>
								<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
								<!-- 简介：  -->
								<p class="introduction">{{item.introduce}}</p>
								<div class="book_button">
									<button v-for="i in item.lable_list">{{i.name}}</button>
								</div>
							</div>
							<div class="blockBookInfo" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? false : true">
								<div class="bookName">
									<span class="bookTxtBox" v-if="item.book_name">
										<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
										<!-- <span :style="{width:(item.book_name.length * 1 ) + 'em' }">{{item.book_name}}</span> -->
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.books_name"></van-notice-bar>
										<!-- <span :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</span> -->
									</span>
								</div>
								<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
								</div>
								<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
								<!-- 简介：  -->
								<p class="introduction">{{item.introduce}}</p>
								<div class="book_button">
									<button v-for="i in item.lable_list">{{i.name}}</button>
								</div>
							</div>
						</div>
						<div class="blockLeft" v-for="(item,index) in bookInfoList"  v-if="wj_show == true && item.progress_status == 2 && item.books_id != null || item.book_id != null">
							<div class="book_Img" @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? true : false">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>
						
							<div class="book_Img" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? false : true">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>
						
							<div class="blockBookInfo" @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? true : false">
								<div class="bookName">
									<span class="bookTxtBox" v-if="item.book_name">
										<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
										<!-- <span :style="{width:(item.book_name.length * 1 ) + 'em' }">{{item.book_name}}</span> -->
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.books_name"></van-notice-bar>
										<!-- <span :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</span> -->
									</span>
								</div>
								<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
								</div>
								<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
								<!-- 简介：  -->
								<p class="introduction">{{item.introduce}}</p>
								<div class="book_button">
									<button v-for="i in item.lable_list">{{i.name}}</button>
								</div>
							</div>
							<div class="blockBookInfo" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? false : true">
								<div class="bookName">
									<span class="bookTxtBox" v-if="item.book_name">
										<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
										<!-- <span :style="{width:(item.book_name.length * 1 ) + 'em' }">{{item.book_name}}</span> -->
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.books_name"></van-notice-bar>
										<!-- <span :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</span> -->
									</span>
								</div>
								<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
								</div>
								<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
								<!-- 简介：  -->
								<p class="introduction">{{item.introduce}}</p>
								<div class="book_button">
									<button v-for="i in item.lable_list">{{i.name}}</button>
								</div>
							</div>
						</div>
						<div class="nulldata" v-if="bookInfoList.length == 0">
							<img src="../../assets/img/data_null.png" alt="">
						</div>
						<!-- <div class="onFooter" v-show="onFooter==1">到底啦</div> -->
					</div>
				</van-list>
			</div>
			<!-- 封面模式 -->
			<div v-else>
				<van-list v-model="loading" :finished="finished" finished-text="没有更多啦" offset="20" :immediate-check="false" @load="onLoad">
				<div class="blockBox bookLishBox" v-if="index == 15">
					<a href="#" v-for="(item,index) in bookInfoList">
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-if="item.books_id" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" />
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-else @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" />
						<p class="bookName" v-if="item.books_name">
							<span v-for="(books_name,bookNameIndex) in item.books_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<p class="bookName" v-else>
							<span v-for="(books_name,bookNameIndex) in item.book_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<!-- <p class="jianjie">{{item.describe}}</p> -->
					</a>
				</div>
				<div class="blockBox bookLishBox" v-else>
					<a href="#" v-for="(item,index) in bookInfoList" @touchstart="gotouchstart01(item.id,item.books_id,item.lock_status)"
					 @touchmove="gotouchmove01" @touchend="gotouchend01(item.id,item.books_id,item.lock_status)" v-if="item.books_id != null && wj_show == true && item.progress_status == 2">
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-if="item.books_id" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" />
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-else @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" />
						<p class="bookName" v-if="item.books_name">
							<span v-for="(books_name,bookNameIndex) in item.books_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<p class="bookName" v-else>
							<span v-for="(books_name,bookNameIndex) in item.book_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<!-- <p class="jianjie">{{item.describe}}</p> -->
					</a>
					<a href="#" v-for="(item,index) in bookInfoList" @touchstart="gotouchstart01(item.id,item.books_id,item.lock_status)"
					 @touchmove="gotouchmove01" @touchend="gotouchend01(item.id,item.books_id,item.lock_status)" v-if="item.books_id != null && wj_show == false && item.progress_status != null">
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-if="item.books_id" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" />
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-else @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" />
						<p class="bookName" v-if="item.books_name">
							<span v-for="(books_name,bookNameIndex) in item.books_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<p class="bookName" v-else>
							<span v-for="(books_name,bookNameIndex) in item.book_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<!-- <p class="jianjie">{{item.describe}}</p> -->
					</a>
				</div>
				</van-list>
			</div>
		</van-pull-refresh>
		<div v-if="sc_isLoading == false">
			<div v-if="fmOrListFn">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多啦" offset="10" :immediate-check="false" @load="onLoad">
					<div class="blockBox" v-if="index == 15">
						<div class="blockLeft" v-for="(item,index) in fileList"  v-if="item.books_id != null || item.book_id != null">
							<div class="book_Img">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>
			
							<div class="blockBookInfo">
								<div class="bookName">
									<span class="bookTxtBox" v-if="item.book_name">
										<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
										<!-- <span :style="{width:(item.book_name.length * 1 ) + 'em' }" v-for="(item,idx) in item.book_name">{{item.book_name}}</span> -->
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.books_name"></van-notice-bar>
										<!-- <span :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</span> -->
									</span>
								</div>
								<div class="auther"><span></span>
									<p><span>万字</span></p>
								</div>
								<p class="introduction">{{item.introduce}}</p>
							</div>
						</div>
						<div class="nulldata" v-if="bookInfoList.length == 0">
							<img src="../../assets/img/data_null.png" alt="">
						</div>
						<!-- <div class="onFooter" v-show="onFooter==1">到底啦</div> -->
					</div>
					<div class="blockBox" v-else>
						<!--  -->
						<div class="blockLeft" v-for="(item,index) in bookInfoList"  v-if="item.books_id != null || item.book_id != null">
							<div class="book_Img" @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? true : false">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>
			
							<div class="book_Img" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? false : true">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>
			
							<div class="blockBookInfo" @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? true : false">
								<div class="bookName">
									<span class="bookTxtBox" v-if="item.book_name">
										<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
										<!-- <span :style="{width:(item.book_name.length * 1 ) + 'em' }">{{item.book_name}}</span> -->
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.books_name"></van-notice-bar>
										<!-- <span :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</span> -->
									</span>
								</div>
								<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
								</div>
								<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
								<!-- 简介：  -->
								<p class="introduction">{{item.introduce}}</p>
								<div class="book_button">
									<button v-for="i in item.lable_list">{{i.name}}</button>
								</div>
							</div>
							<div class="blockBookInfo" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" v-if="item.book_id != null ? false : true">
								<div class="bookName">
									<span class="bookTxtBox" v-if="item.book_name">
										<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
										<!-- <span :style="{width:(item.book_name.length * 1 ) + 'em' }">{{item.book_name}}</span> -->
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.books_name"></van-notice-bar>
										<!-- <span :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</span> -->
									</span>
								</div>
								<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
								</div>
								<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
								<!-- 简介：  -->
								<p class="introduction">{{item.introduce}}</p>
								<div class="book_button">
									<button v-for="i in item.lable_list">{{i.name}}</button>
								</div>
							</div>
						</div>
						<div class="nulldata" v-if="bookInfoList.length == 0">
							<img src="../../assets/img/data_null.png" alt="">
						</div>
						<!-- <div class="onFooter" v-show="onFooter==1">到底啦</div> -->
					</div>
				</van-list>
			</div>
			<!-- 封面模式 -->
			<div v-else>
				<van-list v-model="loading" :finished="finished" finished-text="没有更多啦" offset="20" :immediate-check="false" @load="onLoad">
				<div class="blockBox bookLishBox" v-if="index == 15">
					<a href="javascript:;" v-for="(item,index) in bookInfoList" :key="index">
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-if="item.books_id" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" />
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-else @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" />
						<p class="bookName" v-if="item.books_name">
							<span v-for="(books_name,bookNameIndex) in item.books_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<p class="bookName" v-else>
							<span v-for="(books_name,bookNameIndex) in item.book_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<!-- <p class="jianjie">{{item.describe}}</p> -->
					</a>
				</div>
				<div class="blockBox bookLishBox" v-else>
					<a href="javascript:;" v-for="(item,index) in bookInfoList"  @touchstart="gotouchstart01(item.id,item.books_id,item.lock_status)"
					 @touchmove="gotouchmove01" @touchend="gotouchend01(item.id,item.books_id,item.lock_status)">
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-if="item.books_id" @click="jumpBookinfo(item.books_id,item.lock_status,item.chapter_id)" />
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" v-else @click="jumpBookinfo(item.book_id,item.lock_status,item.chapter_id)" />
						<p class="bookName" v-if="item.books_name">
							<span v-for="(books_name,bookNameIndex) in item.books_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<p class="bookName" v-else>
							<span v-for="(books_name,bookNameIndex) in item.book_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span>
						</p>
						<!-- <p class="jianjie">{{item.describe}}</p> -->
					</a>
				</div>
				</van-list>
			</div>
		</div>
		
		<!-- deleShow -->
		<div class="luntantost" v-show="deleShow == true">
			<!-- <img src="../../assets/img/cat.png" alt=""> -->
			<div class="luntantostbgc">
				<div @click="delBooks" class="active">删除</div>
				<div @click="jumpBookinfoToast" class="active">书本详情</div>
			</div>
		</div>
		<div class='mask' v-show="deleShow == true" @click="hideTost01"></div>
	</div>
</template>

<script>
	import {
		Toast,
		Dialog
	} from 'vant';
	export default {
		data() {
			return {
				bookInfoList: [],
				title: '',
				index: 0,
				pageUrl: '',
				onFooter: 0,
				onPullDown: true, //下拉加载
				page: 1,
				limit: 10,
				selectValue: null,
				selectDate: null,
				showSelect: false,
				showSelectLists: [],
				selectIndex: '',
				fmOrListFn: true,
				fileList: [],
				isLoading: false,
				deleShow: false,
				timeOutEvent: 0,
				clearHfId: '',
				lock_status: '',
				loading: false,
				finished: false,
				refreshing: false,
				wj_show: false,
				sc_isLoading: false,
				categoryDetailList: 0,
				fmOrListFnWj: '',
				order:'',//收藏
			}
		},
		created() {
			this.index = this.$route.query.index;
			// this.get_xianmian_old()
			this.pageUrl = this.$route.query.bookshelfUrl || this.$route.query.url;
			this.com_name = this.$route.query.com_name;
			this.fileList = JSON.parse(localStorage.getItem('fileList')) ? JSON.parse(localStorage.getItem('fileList')) : [];
			if (localStorage.getItem('fmOrListFn') && localStorage.getItem('fmOrListFn') == 6 && this.$route.query.url !=
				'soltPh' && this.index != 11) {
				this.fmOrListFn = false; //显示模式
			} else if (localStorage.getItem('fmOrListFn') && localStorage.getItem('fmOrListFn') == 1 && this.$route.query.url !=
				'soltPh' && this.index != 11) {
				this.fmOrListFn = false; //显示封面模式
				this.limit = 20;
			} else {
				this.fmOrListFn = true; //默认模式
			}
			if(localStorage.getItem('fmOrListFnWj') == 7){
				this.wj_show = true;
			}
			if (this.index == 0) {
				this.get_ranking_qt_list();
			}
			this.title = this.$route.query.title;
			// this.bookInfoList=[];
			
			// 回显排行数据
			this.selectIndex=this.$route.query.selectIndex;
			this.selectValue=this.$route.query.selectValue;
			this.selectDate=this.$route.query.selectDate;
			if(this.selectValue != null){
				this.$axios.post(`${this.$api.ranking_qt_list}?date=${this.selectValue}`).then(res => {
					console.log(res, '强推排行')
					if (res.status == 200) {
						console.log(res)
						// this.bookInfoList = this.bookInfoList.concat(res.data.data.plate_book_list)
						this.bookInfoList = res.data.data.plate_book_list;
						this.showSelectLists = res.data.data.date_lists;
						this.showSelectLists.unshift({
							date: null,
							plate_info_id: null,
							time: null
						})
						if (this.bookInfoList.length < this.limit) {
							this.onFooter = 1;
						}
					}
				})
			}
		},
		mounted() {
			this.selectTitle(this.index)
			// window.addEventListener('scroll', this.scroll, false) // 监听（绑定）滚轮滚动事件
		},
		methods: {
			showSelectBox() {
				this.showSelect = !this.showSelect
			},
			onRefresh() {
				setTimeout(() => {
					Toast('刷新成功');
					this.isLoading = false;
					//收藏列表
					this.page = 1;
					this.bookInfoList = [];
					if(localStorage.getItem('fmOrListFnWj') == 3){//更新
						this.order = 2;
					}else if(localStorage.getItem('fmOrListFnWj') == 4){//收藏
						this.order = 1;
					}else if(localStorage.getItem('fmOrListFnWj') == 5){//阅读
						this.order = 3;
					}else if(localStorage.getItem('fmOrListFnWj') == 7){//完结
						this.order = 4;
					}
					this.get_collect_list_ranking(this.order);
				}, 1000);
			},
			gotouchstart01(id, books_id, lock_status) {
				this.clearHfId = books_id;
				this.lock_status = lock_status;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.deleShow = true;
				}, 600); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend01(id, books_id, lock_status) {
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove01() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			// 删除书单
			delBooks() {
				Dialog.confirm({
						// title: '',
						message: '删除该书',
					})
					.then(() => {
						// 收藏删除
						if(this.index == 12){
							this.$axios.post(this.$api.xianmian_collect, {
								books_ids: this.clearHfId
							}).then(res => {
								this.deleShow = false;
								Toast(res.data.msg);
								this.page=1;
								this.bookInfoList = [];
								if(localStorage.getItem('fmOrListFnWj') == 3){//更新
									this.order = 2;
								}else if(localStorage.getItem('fmOrListFnWj') == 4){//收藏
									this.order = 1;
								}else if(localStorage.getItem('fmOrListFnWj') == 5){//阅读
									this.order = 3;
								}else if(localStorage.getItem('fmOrListFnWj') == 7){//阅读
									this.order = 4;
								}
								this.get_collect_list_ranking(this.order);
							})
						}else if(this.index == 13){ //最近阅读删除
							this.$axios.post(this.$api.del_history_book, {
								books_id: this.clearHfId
							}).then(res => {
								this.deleShow = false;
								Toast(res.data.msg);
								// this.bookInfoList = [];
								this.page=1;
								this.get_read_history_ranking()
							})
						}
						this.scInfoData = JSON.parse(localStorage.getItem('scRadio'));
						for (var i = 0; i < this.scInfoData.length; i++) {
							if (this.scInfoData[i].scBookID == this.clearHfId) {
								this.scInfoData.splice(i, 1);
								localStorage.setItem('scRadio', JSON.stringify(this.scInfoData))
								return this.scInfoData
							}
						}
						this.deleShow = false;
					})
					.catch(() => {
						// on cancel
					});
			},
			jumpBookinfoToast() {
				if (this.lock_status == 0) {
					Toast('该书本已锁定，暂时无法查看')
				} else {
					this.$router.push({
						path: '/bookinfo',
						query: {
							id: this.clearHfId,
							bookshelfUrl: 'bookshelfUrlsj',
						}
					})
				}
			},
			hideTost01() {
				this.deleShow = false;
			},
			selectItemFn(value, index) {
				this.selectValue = value.date;
				this.selectDate = value.time;
				this.selectIndex = index
				this.showSelect = !this.showSelect;
				if (this.selectValue != null) {
					this.$axios.post(`${this.$api.ranking_qt_list}?date=${this.selectValue}`).then(res => {
						console.log(res, '强推排行')
						if (res.status == 200) {
							console.log(res)
							// this.bookInfoList = this.bookInfoList.concat(res.data.data.plate_book_list)
							this.bookInfoList = res.data.data.plate_book_list;
							this.showSelectLists = res.data.data.date_lists;
							this.showSelectLists.unshift({
								date: null,
								plate_info_id: null,
								time: null
							})
							if (this.bookInfoList.length < this.limit) {
								this.onFooter = 1;
							}
						}
					})
				} else {
					this.get_ranking_qt_list();
				}

			},
			back() {
				if (this.pageUrl == 'bookshelfUrl' && this.com_name == 'home' || this.com_name == 'home') {
					this.$router.push({
						path: '/bookshelf',
						query: {
							com_name: this.com_name
						}
					});
				} else if (this.pageUrl == 'soltPh') {
					this.$router.push('/bookcity')
				} else {
					this.$router.go(-1);
				}
			},
			selectTitle(index) {
				if (index == 0) {
					this.title = '强推排行'
					// this.get_ranking_qt_list()
				} else if (index == 1) {
					this.title = '完结金榜'
					this.page = 1;
					this.get_ranking_wj_list()
				} else if (index == 2) {
					this.title = '萌新榜';
					this.page = 1;
					this.get_ranking_mx_list()
				} else if (index == 3) {
					this.title = '月榜'
					this.page = 1;
					this.get_ranking_yue_list()
				} else if (index == 4) {
					this.title = '季榜'
					this.page = 1;
					this.get_ranking_ji_list()
				} else if (index == 5) {
					this.title = '云尼斯榜'
					this.page = 1;
					this.get_ranking_yns_list()
				} else if (index == 6) {
					this.title = '金云朵榜'
					// this.page = 1;
					this.get_ranking_jyd_list()
				} else if (index == 7) {
					this.title = '勤奋修仙榜'
					this.page = 1;
					this.get_ranking_qfxx_list()
				} else if (index == 8) {
					this.title = 'VIP新文总榜'
					this.page = 1;
					this.get_ranking_vip_list()
				} else if (index == 9) {
					this.title = '收入金榜'
					this.page = 1;
					this.get_ranking_sr_list()
				} else if (index == 11) {
					this.title = '黑马榜'
					this.page = 1;
					this.get_dark_horse_ranking()
				} else if (index == 12) {
					this.title = '我的收藏';
					this.page = 1;
					this.bookInfoList=[];
					this.sc_isLoading = true;
					if(localStorage.getItem('fmOrListFnWj') == 3){//更新
						this.order = 2;
						this.wj_show = false;
					}else if(localStorage.getItem('fmOrListFnWj') == 4){//收藏
						this.order = 1;
						this.wj_show = false;
					}else if(localStorage.getItem('fmOrListFnWj') == 5){//阅读
						this.order = 3;
						this.wj_show = false;
					}else if(localStorage.getItem('fmOrListFnWj') == 7){//完结
						this.order = 4;
						this.wj_show = true;
					}
					this.get_collect_list_ranking(this.order);
				} else if (index == 13) {
					this.title = '最近阅读';
					this.page = 1;
					this.get_read_history_ranking()
				} else if (index == 14) {
					this.title = '热门推荐'
					this.page = 1;
					this.get_hot_books_ranking()
				} else if (index == 15) {
					this.title = '本地导入'
				}
				
			},
			type_listFn() {
				this.$axios.post(`${this.$api.type_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					console.log(res, '历史限免')
					if (res.status == 200) {
						this.bookInfoList = res.data.data;
						// this.bookInfoList = this.bookInfoList.concat(res.data.data)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						if (res.data.data.count === this.categoryDetailList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						this.page = 2;
					}

				})
			},
			get_xianmian_old() {
				this.$axios.post(`${this.$api.xianmian_old}?page=${this.page}&limit=${this.limit}`).then(res => {
					console.log(res, '历史限免')
					if (res.status == 200) {
						// this.bookInfoList = this.bookInfoList.concat(res.data.data)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						this.bookInfoList = res.data.data;
						if (res.data.data.count === this.categoryDetailList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						this.page = 2;

					}

				})
			},
			//强推排行
			get_ranking_qt_list() {
				// ${this.$api.ranking_qt_list}?page=${this.page}&limit=${this.limit}
				this.$axios.post(`${this.$api.ranking_qt_list}`).then(res => {
					console.log(res, '强推排行')
					if (res.status == 200) {
						console.log(res)
						// this.bookInfoList = this.bookInfoList.concat(res.data.data.plate_book_list)
						this.bookInfoList = res.data.data.plate_book_list;
						this.showSelectLists = res.data.data.date_lists;
						this.showSelectLists.unshift({
							date: null,
							plate_info_id: null,
							time: null
						})
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						this.finished = true
					}
				})
			},
			//完结金榜
			get_ranking_wj_list() {
				this.$axios.post(`${this.$api.ranking_wj_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						// this.bookInfoList = this.bookInfoList.concat(res.data.data.list)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						// this.bookInfoList = res.data.data.list;
						this.bookInfoList = this.bookInfoList.concat(res.data.data.list)
						if (res.data.data.count === this.categoryDetailList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}

				})
			},
			//萌新榜
			get_ranking_mx_list() {
				this.$axios.post(`${this.$api.ranking_mx_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						// this.bookInfoList = res.data.data.list;
						this.bookInfoList = this.bookInfoList.concat(res.data.data.list);
						if (res.data.data.total === this.bookInfoList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}
				})
				// this.$axios.post(`${this.$api.ranking_qywj}`,{
				// 	start: 1,
				// 	plate_info_id: 97
				// }).then(res => {
				// 	if (res.status == 200) {
				// 		this.bookInfoList = res.data.data.plate_list;
				// 		if (res.data.data.total === this.bookInfoList.length) {
				// 			this.finished = true
				// 		} else {
				// 			this.finished = false
				// 		}
				
				// 		this.refreshing = false;
				// 		this.loading = false;
				// 	}
				// })
			},
			onLoad() {
				if (this.index == 1) {
					//完结金榜
					// this.$axios.post(`${this.$api.ranking_wj_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					this.get_ranking_wj_list()
				} else if (this.index == 2) {
					//萌新榜
					// this.$axios.post(`${this.$api.ranking_mx_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					this.get_ranking_mx_list()
				} else if (this.index == 3) {
					//月榜
					// this.$axios.post(`${this.$api.ranking_yue_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					this.get_ranking_yue_list()
				} else if (this.index == 4) {
					//季榜
					// this.$axios.post(`${this.$api.ranking_ji_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					
					this.page +=1;
					this.get_ranking_ji_list()
				} else if (this.index == 5) {
					//云尼斯总榜
					// this.$axios.post(`${this.$api.ranking_yns_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					this.get_ranking_yns_list()
				} else if (this.index == 6) {
					//金云朵总榜
					// this.$axios.post(`${this.$api.ranking_jyd_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					this.get_ranking_jyd_list()
				} else if (this.index == 7) {
					//勤奋修仙帮
					// this.$axios.post(`${this.$api.ranking_qfxx_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					this.get_ranking_qfxx_list()
				} else if (this.index == 8) {
					//vip新文总榜
					// this.$axios.post(`${this.$api.ranking_vip_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					this.get_ranking_vip_list()
				} else if (this.index == 9) {
					//收入金榜
					// this.$axios.post(`${this.$api.ranking_sr_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	if (this.bookInfoList.length < res.data.data.total) {
					// 		this.page++;
					// 		this.loading = false
					// 	} else {
					// 		this.finished = true
					// 		this.loading = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					this.get_ranking_sr_list()
				} else if (this.index == 12) {
					// this.$axios.post(`${this.$api.collect_list_ranking}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data.list;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	// if (this.bookInfoList.length < res.data.data.total) {
					// 	this.page++;
					// 	this.loading = false
					// 	// } else {
					// 	// 	this.finished = true
					// 	// 	this.loading = true
					// 	// }
					// 	if(datas.length == 0){
					// 		this.finished = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page +=1;
					if(localStorage.getItem('fmOrListFnWj') == 3){//更新
						this.order = 2;
					}else if(localStorage.getItem('fmOrListFnWj') == 4){//收藏
						this.order = 1;
					}else if(localStorage.getItem('fmOrListFnWj') == 5){//阅读
						this.order = 3;
					}else if(localStorage.getItem('fmOrListFnWj') == 7){//阅读
						this.order = 4;
					}
					this.get_collect_list_ranking(this.order);
				} else if (this.index == 13) {
					//最近阅读
					// this.$axios.post(`${this.$api.read_history_ranking}?page=${this.page}&limit=${this.limit}`).then(res => {
					// 	let datas = res.data.data;
					// 	this.bookInfoList = this.bookInfoList.concat(datas)
					// 	// if (this.bookInfoList.length < res.data.data.total) {
					// 	this.page++;
					// 	this.loading = false
					// 	// } else {
					// 	// 	this.finished = true
					// 	// 	this.loading = true
					// 	// }
					// 	if(datas.length == 0){
					// 		this.finished = true
					// 	}
					// }).catch(() => {
					// 	Toast('接口异常')
					// 	this.finished = true
					// });
					this.page += 1;
					this.get_read_history_ranking()
				} else if (this.index == 14) {
					//热门推荐
					this.$axios.post(`${this.$api.hot_books_ranking}?page=${this.page}&limit=${this.limit}`).then(res => {
						let datas = res.data.data;
						this.bookInfoList = this.bookInfoList.concat(datas)
						// if (this.bookInfoList.length < res.data.data.total) {
						this.page++;
						this.loading = false
						// } else {
						// 	this.finished = true
						// 	this.loading = true
						// }
						if(datas.length == 0){
							this.finished = true
						}
					}).catch(() => {
						Toast('接口异常')
						this.finished = true
					});
				}


			},
			//月榜
			get_ranking_yue_list() {
				this.$axios.post(`${this.$api.ranking_yue_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						this.bookInfoList = this.bookInfoList.concat(res.data.data.list)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						// this.bookInfoList = res.data.data.list;
						if (res.data.data.total === this.bookInfoList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}
				})
				// this.$axios.post(`${this.$api.ranking_qywj}`,{
				// 	start: 1,
				// 	plate_info_id: 98
				// }).then(res => {
				// 	if (res.status == 200) {
				// 		this.bookInfoList = res.data.data.plate_list;
				// 		if (res.data.data.total === this.bookInfoList.length) {
				// 			this.finished = true
				// 		} else {
				// 			this.finished = false
				// 		}
				
				// 		this.refreshing = false;
				// 		this.loading = false;
				// 	}
				// })
			},
			//季榜
			get_ranking_ji_list() {
				this.$axios.post(`${this.$api.ranking_ji_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						console.log(res)
						this.bookInfoList = this.bookInfoList.concat(res.data.data.list)
						if (res.data.data.total === this.bookInfoList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}
				})
				// this.$axios.post(`${this.$api.ranking_qywj}`,{
				// 	start: 1,
				// 	plate_info_id: 99
				// }).then(res => {
				// 	if (res.status == 200) {
				// 		this.bookInfoList = res.data.data.plate_list;
				// 		if (res.data.data.total === this.bookInfoList.length) {
				// 			this.finished = true
				// 		} else {
				// 			this.finished = false
				// 		}
				
				// 		this.refreshing = false;
				// 		this.loading = false;
				// 	}
				// })
			},
			//云尼斯总榜
			get_ranking_yns_list() {
				this.$axios.post(`${this.$api.ranking_yns_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						this.bookInfoList = this.bookInfoList.concat(res.data.data.list)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						// this.bookInfoList = res.data.data.list;
						if (res.data.data.total === this.bookInfoList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}
				})
				
				// this.$axios.post(`${this.$api.ranking_qywj}`,{
				// 	start: 1,
				// 	plate_info_id: 103
				// }).then(res => {
				// 	if (res.status == 200) {
				// 		this.bookInfoList = res.data.data.plate_list;
				// 		if (res.data.data.total === this.bookInfoList.length) {
				// 			this.finished = true
				// 		} else {
				// 			this.finished = false
				// 		}
				
				// 		this.refreshing = false;
				// 		this.loading = false;
				// 	}
				// })
			},
			//金云朵总榜
			get_ranking_jyd_list() {
				this.$axios.post(`${this.$api.ranking_jyd_list}`).then(res => {
					if (res.status == 200) {
						this.bookInfoList = res.data.data.list
						this.finished = true
					}
				})
			},
			//勤奋修仙帮
			get_ranking_qfxx_list() {
				this.$axios.post(`${this.$api.ranking_qfxx_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						this.bookInfoList = this.bookInfoList.concat(res.data.data.list)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						// this.bookInfoList = res.data.data.list;
						if (res.data.data.total === this.bookInfoList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}
				})
			},
			//vip新文总榜
			get_ranking_vip_list() {
				this.$axios.post(`${this.$api.ranking_vip_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						this.bookInfoList = this.bookInfoList.concat(res.data.data.list)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						// this.bookInfoList = res.data.data.list;
						if (res.data.data.total === this.bookInfoList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}
				})
			},
			//收入金榜
			get_ranking_sr_list() {
				this.$axios.post(`${this.$api.ranking_sr_list}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						this.bookInfoList = this.bookInfoList.concat(res.data.data.list)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						// this.bookInfoList = res.data.data.list;
						if (res.data.data.total === this.bookInfoList.length || res.data.data.list == 0) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}
				})
			},
			//黑马榜
			get_dark_horse_ranking() {
				this.$axios.post(`${this.$api.dark_horse_ranking}`).then(res => {
					if (res.status == 200) {
						console.log(res, '黑马榜')
						this.bookInfoList = res.data.data
						this.finished = true
					}
				})
			},
			//热门推荐
			get_hot_books_ranking() {
				this.$axios.post(`${this.$api.hot_books_ranking}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						console.log(res, '热门推荐')
						// this.bookInfoList = this.bookInfoList.concat(res.data.data)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						this.bookInfoList = res.data.data;
						if (res.data.data.total === this.bookInfoList.length) {
							this.finished = true
						} else {
							this.finished = false
						}

						this.refreshing = false;
						this.loading = false;
						this.page = 2;
					}
				})
			},
			//阅读历史
			get_read_history_ranking() {
				// ?page=${this.page}&limit=${this.limit}
				this.$axios.post(`${this.$api.read_history_ranking}`).then(res => {
					if (res.status == 200) {
						// this.bookInfoList = this.bookInfoList.concat(res.data.data)
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						this.bookInfoList = res.data.data;
						// if (res.data.data.total === this.bookInfoList.length) {
							this.finished = true
						// } else {
						// 	this.finished = false
						// }
						this.refreshing = false;
						this.loading = false;
						// this.page = 2;
					}
				})
			},
			//收藏列表
			get_collect_list_ranking(order) {
				this.order = order;
				this.$axios.post(`${this.$api.collect_list_ranking}?page=${this.page}&limit=20&order=${this.order}`).then(res => {
					if (res.status == 200) {
						this.bookInfoList = this.bookInfoList.concat(res.data.data);
						if(res.data.data == [] || res.data.data.length < 20){
							this.finished = true;
							this.refreshing = false;
							this.loading = false;
						}else{
							this.finished = false
						}
						// if (this.bookInfoList.length < this.limit) {
						// 	this.onFooter = 1;
						// }
						// this.bookInfoList = res.data.data;
						// if (res.data.data.total === this.bookInfoList.length) {
							
						// } else {
						// 	this.finished = false
						// }

						
						// this.page = 2;
					}
				})
			},
			// 滚动加载分页
			scroll() {
				var that = this
				// scrollTop 滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				// windowHeight 可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				// scrollHeight 滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				// 滚动条到底部的条件
				// if (scrollTop + windowHeight == scrollHeight && that.onPullDown == true) {
				// 	// 加载数据 
				// 	that.page = that.page + 1
				// 	// if (that.index == 0) {
				// 	// 	that.get_ranking_qt_list()
				// 	// } else
				// 	 if (that.index == 1) {
				// 		that.get_ranking_wj_list()
				// 	} else if (that.index == 2) {
				// 		that.get_ranking_mx_list()
				// 	} else if (that.index == 3) {
				// 		that.get_ranking_yue_list()
				// 	} else if (that.index == 4) {
				// 		that.get_ranking_ji_list()
				// 	} else if (that.index == 5) {
				// 		that.get_ranking_yns_list()
				// 	} else if (that.index == 6) {
				// 		that.get_ranking_jyd_list()
				// 	} else if (that.index == 7) {
				// 		that.get_ranking_qfxx_list()
				// 	} else if (that.index == 8) {
				// 		that.get_ranking_vip_list()
				// 	} else if (that.index == 9) {
				// 		that.get_ranking_sr_list()
				// 	} else if (that.index == 11) {
				// 		that.get_dark_horse_ranking()
				// 	} else if (that.index == 12) {
				// 		that.get_collect_list_ranking()
				// 	} else if (that.index == 13) {
				// 		that.get_read_history_ranking()
				// 	} else if (that.index == 14) {
				// 		that.get_hot_books_ranking()
				// 	}

				// }
			},
			// 跳转详情页
			jumpBookinfo(val, lock_status, chapter_id) {
				if (lock_status == 0) {
					Toast('该书本已锁定，暂时无法查看')
				} else {
					console.log('val', val)
					console.log('lock_status', lock_status)
					console.log('chapter_id', chapter_id)
					if (this.title == '最近阅读') {
						this.$router.push({
							path: '/readbook',
							query: {
								id: val,
								readId: chapter_id
							}
						})
					} else if (this.title == '我的收藏') {
						this.$router.push({
							path: '/readbook',
							query: {
								id: val,
								readId: chapter_id
							}
						})
					} else {
						this.$router.push({
							path: '/bookinfo',
							query: {
								id: val,
								soltPhDetailPage: this.pageUrl,
								soltPhDetailIndex: this.index,
								com_name: this.com_name,
								title: this.title,
								selectIndex: this.selectIndex,
								selectValue:this.selectValue,
								selectDate:this.selectDate,
								
							}
						})
					}

				}
			},
			//作者专栏
			toZz(val) {
				this.$router.push({
					path: '/autherZl',
					query: {
						user_id: val
					}
				})
			},

			keywordsFn(word) {
				console.log(word);
				this.$router.push({
					path: '/searchResult',
					query: {
						keywordHost: word,
						url: this.pageUrl,
						index: this.$route.query.index,
						com_name: this.com_name,
					}
				})
			},
		},
		destroyed() {
			window.removeEventListener('scroll', this.scroll) //  离开页面清除（移除）滚轮滚动事件
		}
	}
</script>

<style scoped lang="less">
	.van-pull-refresh {
		height: 100vh;
		overflow-y: scroll;
	}

	.wqxmBox {

		// 头部
		.headerBox {
			height: 160px;
			// background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			.headerQuery {
				margin-top: 70px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 90px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						height: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
					line-height: 90px;
				}

				.rightSelect {
					position: absolute;
					top: 50%;
					right: 16px;
					transform: translateY(-50%);
					background-color: #f0f0f0;
					border: 0;
					padding: 10px 20px;
					font-size: left;
					border-radius: 5px;

					p {
						display: inline-block;
						color: #ff4081;
					}

					img {
						margin-left: 10px;
						vertical-align: middle;
						width: 20px;
					}
				}

				.selectItem {
					position: absolute;
					top: 100%;
					right: 16px;
					background-color: #fff;
					border: 1px solid #f0f0f0;
					/*no*/
					line-height: 60px;
					z-index: 100;
					height: 360px;
					overflow-x: hidden;
					overflow-y: scroll;

					li {
						padding: 0px 20px;
						text-align: center;
						font-size: 28px;
						/*px*/
					}

					.active_color {
						color: #ff4081;
					}
				}
			}

		}

		//列表数据
		.blockBox {
			overflow: hidden;
			position: relative;
			padding: 0 16px;
			background-color: #fff;

			.blockLeft {
				display: flex;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.book_Img {
					// width: 138px;
					height: 270px;
					width: 180px;
					overflow: hidden;

					-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);

					/*no*/
					img {
						display: block;
						float: left;
						width: 180px;
						height: 270px;
						/*px*/
					}
				}

				.blockBookInfo {
					margin-left: 18px;
					width: calc(100vw - 200px);
					font-size: 26px;
					/*px*/
					line-height: 30px;
					padding-top: 10px;

					.auther {
						font-size: 28px;
						/*px*/
						color: #676767;
						position: relative;

						.btn_sc {
							flex: 1;

							button {
								position: absolute;
								top: 0px;
								right: 0px;
								border: 0;
								background-color: #fff8fa;
								outline: none;
								border: 1px solid #fec6d5;
								/*no*/
								border-radius: 28px;
								padding: 0px 20px;
								line-height: 40px;
								color: #fa7298;
								font-size: 26px;
								/*px*/
							}
						}
					}

					.bookName {
						// line-height: 40px;
						padding-bottom: 20px;
						font-size: 30px;
						/*px*/
						color: #000000;

						// font-weight: bold;
						.bookTxtBox {
							// display: inline-block;
							// width: calc(100vw - 220px);
							// height: 30px;
							// overflow: hidden;
							// overflow-x: scroll;
							// span{
							// 	display: inline-block;
							// }
							width: calc(100vw - 260px);
							font-size: 30px;
							/*px*/
							color: #000;
							overflow: hidden;

							.van-swipe .van-swipe__track--vertical .van-swipe-item {
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}

							.van-notice-bar {
								background: rgba(0, 0, 0, 0);
								color: #000;
								height: 30px;
								padding: 0;
							}
						}

						.name {
							font-size: 30px;
							/*px*/
							color: #000000;
						}

					}

					.auther {
						color: #000;
						opacity: 0.6;
						font-size: 26px;

						/*px*/
						p {
							display: inline-block;
							float: right;
							font-weight: 400;

							span {
								margin-left: 8px;
								color: #000;
								font-size: 26px;
								/*px*/
							}

							// .wanjie {
							// 	color: #ff0000;
							// }

							// .txtGreen {
							// 	color: #5ca615;
							// }
						}
					}

					.bookType,
					.introduction {
						padding-top: 10px;
						color: #000;
						opacity: 0.4;
						font-size: 24px;
						/*px*/
					}

					.introduction {
						width: 60vw;
						padding-top: 10px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}

					.book_button {
						margin-top: 15px;
						align-items: center;

						button {
							border: 0;
							outline: none;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							line-height: 36px;
							/*px*/
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							font-size: 24px;
							/*px*/
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							margin-bottom: 10px;
						}

						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}


		}

		// 封面模式
		.bookLishBox {
			background-color: #fff;
			overflow: hidden;
			height: 100%;
			padding: 15px 16px;

			a:nth-child(4n) {
				padding-right: 0;
			}

			a {
				text-decoration: none;
				color: #3d3d3d;
				float: left;
				width: calc((100vw - 62px) / 4);
				text-align: center;
				font-size: 16px;
				/*px*/
				margin-bottom: 40px;
				padding-right: 10px;

				img {
					width: 155px;
					height: 220px;
					/*px*/
					-webkit-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					-moz-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
				}

				.bookName,
				.jianjie {
					overflow: hidden;
					white-space: nowrap;
					// text-overflow: ellipsis;
					// padding: 0 10px;
					margin: 0 auto;
					-webkit-line-clamp: 1;
					line-clamp: 1;
				}

				.bookName {
					padding-top: 10px;
					font-size: 30px;
					/*px*/
				}

				.jianjie {
					overflow: hidden;
					color: #a3a3a3;
					font-size: 22px;
					/*px*/
					padding-top: 5px;
				}
			}
		}
	}

	.nulldata {
		width: 100%;
		margin-top: 30%;
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			width: 160px;
		}
	}

	//弹窗
	.luntantost {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100vw;
		// height: 454px;
		background: url(../../assets/img/pltost.png) no-repeat;
		background-size: 100%;
		z-index: 120;

		img {
			position: absolute;
			bottom: 40px;
			left: 0;
			width: 100%;
		}

		.luntantostbgc {
			margin-top: 124px;
			z-index: 10000 !important;
			background: url(../../assets/img/dog.png) no-repeat #fff;
			background-size: 114% 88%;
			background-position: 0px 50%;

			div {
				line-height: 120px;
				text-align: center;
				color: #737373;
				font-size: 30px;
				/*px*/
				z-index: 1000 !important;
			}

			div.active {
				color: #ff4081;
			}

		}

	}

	.mask {
		position: fixed;
		bottom: 0px;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, .3);
		z-index: 100;
	}
</style>
